import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Check',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19.104 16.53" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M6.928 16.03a1.277 1.277 0 01-.909-.377L.876 10.51a1.286 1.286 0 011.818-1.818l4.127 4.127 9.388-11.736a1.286 1.286 0 112.008 1.607L7.932 15.547a1.286 1.286 0 01-.932.479z", fill: "currentColor", stroke: "currentColor" }
      })]
    );
  }
};